<template>
  <a-modal
    :visible.sync="TipDialogVisible"
    width="400px"
    class="member-limit-dialog-box "
    :mask-closable="false"
    :footer="null"
    @cancel="TipDialogVisible=false"
  >
    <div
      class="dialog-tip-box dialog-tip-blue"
    >
      <i class="icon iconfont iconicon-test34" />
      <h2>{{ $t('message["431"]') }}</h2>
      <div class="d-tip-con">
        <template v-if="bindType==='mobile'">
          {{ mergeTelTipTxt[0] }} {{ value }} {{ mergeTelTipTxt[1] }}？
        </template>
        <template v-else-if="bindType==='email'">
          {{ mergeEmailTipTxt[0] }} {{ value }} {{ mergeEmailTipTxt[1] }}？
        </template>
        <template v-else-if="bindType==='user'">
          {{ mergetTipTxt[0] }} {{ value }} {{ mergetTipTxt[1] }}
        </template>
      </div>
      <div class="limit-btn-box">
        <a-button
          type="primary"
          @click="triggerMerge"
        >
          {{ $t('message["426"]') }}
        </a-button>
        <a-button
          @click="TipDialogVisible=false"
        >
          {{ $t('message["896"]') }}
        </a-button>
        <bind-tips-dialog
          ref="tipsDialog"
          :bind-type="bindType"
          :value="value"
          :type-error="typeError"
        />
      </div>
      <merge-form
        ref="mergeFormDia"
        :datas="formDatas"
        type="bind2"
      />
    </div>
  </a-modal>
</template>
<script>
import { setAuth } from '@/lib/storage'
import BindTipsDialog from './BindTipsDialog'
import MergeForm from '@/components/pc/account/MergeForm'
import { mapActions, mapState } from 'vuex'
export default {
  components: {
    BindTipsDialog,
    MergeForm
  },
  props: {
    bindType: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    }
    // userid: {
    //   type: Number,
    //   default: 0
    // }
  },
  data () {
    return {
      TipDialogVisible: false,
      submiting: false,
      typeError: 0,
      formDatas: {}
    }
  },
  computed: {
    ...mapState('account/modify', ['userid']),
    mergetTipTxt () {
      return this.$t('message["201"]').split('|')
    },
    mergeTelTipTxt () {
      return this.$t('message["1114"]').split('|')
    },
    mergeEmailTipTxt () {
      return this.$t('message["1507"]').split('|')
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions('account/modify', ['mergeUser']),
    changeLimitDialog (b) {
      this.TipDialogVisible = b
    },
    async triggerMerge (val) {
      // this.$refs.mergeFormDia.changeVisible(true)
      // this.typeError = 104
      // this.$refs.tipsDialog.changeLimitDialog(true)
      const chain = await this.mergeUser()
      chain.params({ binduserid: this.userid })
        .onSuccess(res => {
          this.TipDialogVisible = false
          setAuth(res.Authorization)
          this.$store.commit('setAuth', res.Authorization, { root: true })
          this.$router.push({ name: 'OrgIndex' })
        })
        .onNetSuccess(raw => {
          const res = raw.data
          if (res.error === 104 || (res.error === 105)) {
            this.typeError = res.error
            this.TipDialogVisible = false
            this.$refs.tipsDialog.changeLimitDialog(true)
          } else if (res.error === 115) {
            this.formDatas = res.payload
            this.TipDialogVisible = false
            this.$refs.mergeFormDia.changeVisible(true)
          }
        })
        .config({ warn: false })
        .fetch()
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-tip-blue {
  .icon-tips-info1 {
    color: #4a90e2;
  }
}
</style>
